module.exports = __webpack_public_path__ + "assets/img/lefttop_bg.24d4ab52.png";